<script type="text/ecmascript-6">
    import DesignerQuestionDoorColourExternal from "../DesignerQuestionDoorColourExternal.vue";

    export default {
        mixins: [
            DesignerQuestionDoorColourExternal
        ],
    }
</script>
